type ImageManifest = Record<string, string>

let imageManifest: ImageManifest | null = null

// Load image manifest from JSON
const loadImageManifest = async (): Promise<ImageManifest> => {
  if (imageManifest !== null) {
    return imageManifest
  }

  try {
    const response = await fetch("/image-manifest.json")
    if (!response.ok) {
      throw new Error(`Failed to load image manifest: ${response.statusText}`)
    }
    const manifest = (await response.json()) as ImageManifest
    imageManifest = manifest
    return manifest
  } catch (error) {
    console.error("Error loading image manifest:", error)
    return {}
  }
}

const filterModules = (
  modules: Record<string, string>,
  deviceType: "mobile" | "desktop",
  website?: string,
  prefix?: string
) => {
  const map = new Map<string, { key: string; value: string }>()

  Object.entries(modules).forEach(([path, url]) => {
    if (website && !path.includes(`${website}/`)) return
    const fileName = path.split("/").pop()!
    const [fileRealName] = fileName.split(".")
    const name = prefix ? `${prefix}_${fileRealName}` : fileRealName
    const isExist = map.has(name)
    const isReplace = isExist && path.includes(deviceType)

    if (!isExist || isReplace) {
      map.set(name, {
        key: fileName,
        value: url
      })
    }
  })

  const result = [...map.values()].reduce<Record<string, string>>(
    (obj, { key, value }) => ({ ...obj, [key]: value }),
    {}
  )

  return result
}

export const loadFile = async (deviceType: "mobile" | "desktop", website: string) => {
  const manifest = await loadImageManifest()

  // Filter manifest entries that match the pattern: labels/**/*.{png,svg,jpg,jpeg}
  const filteredManifest = Object.entries(manifest).reduce<Record<string, string>>(
    (acc, [path, url]) => {
      if (path.includes("/labels/") && /\.(png|svg|jpg|jpeg|webp)$/i.test(path)) {
        return { ...acc, [path]: url }
      }
      return acc
    },
    {}
  )

  return filterModules(filteredManifest, deviceType, website, "custom")
}

export const loadDefaultFile = async (deviceType: "mobile" | "desktop") => {
  const manifest = await loadImageManifest()

  // Filter manifest entries that match the pattern: share/**/images/**/*.{png,svg,jpg,jpeg}
  const filteredManifest = Object.entries(manifest).reduce<Record<string, string>>(
    (acc, [path, url]) => {
      if (
        path.includes("/share/") &&
        path.includes("/images/") &&
        /\.(png|svg|jpg|jpeg|webp)$/i.test(path)
      ) {
        return { ...acc, [path]: url }
      }
      return acc
    },
    {}
  )

  return filterModules(filteredManifest, deviceType)
}
